import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Select,
  MenuItem,
  Stack,
  Box,
  Grid,
  Typography,
  List,
  Button,
} from "@mui/material";
import { Card } from "../../ui/Card";
import { DatePickerEl } from "../../ui/uiImport";
import { useEffect, useState } from "react";
import {
  getCustomerList,
  ListDataTypeForCustomer,
  getProductsDetails,
  useOrderdata,
  ProductDataType,
} from "./dashboardApi";
import dayjs, { Dayjs } from "dayjs";
import { StyledSeperator } from "../../ui/Seperator";
import {
  PublicIcon,
  TrackChangesIcon,
  HailIcon,
  InventoryIcon,
} from "../../../common/iconsData";
import { FilterAlt } from "@mui/icons-material";

import { PieChart } from "@mui/x-charts";

import { NoDataFound } from "../../../common/NoDataFound";
import useDashboardShipmentFilter, {
  PaymentData,
  ServiceData,
  ShipmentData,
} from "./useDashboardShipmentFilter";
import { OrderTabFilter } from "./OrderTabFilter";

const OrderTab = () => {
  const [customerData, setCustomerData] = useState<ListDataTypeForCustomer[]>(
    []
  );
  const [productData, setProductData] = useState<ProductDataType[]>([]);
  const username = localStorage.getItem("hipship-username") || "User";
  const isUser = username === "Cipla";

  const {
    paymentMode,
    serviceMode,
    shipmentMode,
    startDate,
    endDate,
    indexOfPayment,
    indexOfService,
    indexOfShipment,
    handlePaymentChange,
    handleDateChange,
    handleServiceFilter,
    handleShipmentChange,
    serviceData,
  } = useDashboardShipmentFilter();

  const { data } = useOrderdata(
    PaymentData[indexOfPayment]?.filter,
    serviceData?.[indexOfService] as string,
    ShipmentData[indexOfShipment]?.filter,
    startDate as Dayjs,
    endDate as Dayjs
    // serviceData?.[indexOfService] as string
  );
  const [openFilter, setOpenFilter] = useState(false);

  useEffect(() => {
    async function getAsync() {
      const { data: data2 } = await getCustomerList(
        startDate as Dayjs,
        endDate as Dayjs
      );
      setCustomerData(data2?.data);

      const { data: data3 } = await getProductsDetails(
        startDate as Dayjs,
        endDate as Dayjs
      );
      setProductData(data3?.data);
    }
    getAsync();
  }, [startDate, endDate, shipmentMode, paymentMode, serviceMode]);

  return (
    <>
      <Typography fontWeight={"400"} mb={2}>
        Last 10 Days Details
      </Typography>
      {/* filter */}
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        rowGap={"20px"}
        columnGap={"20px"}
        marginBottom={"40px"}
      >
        <div className="common-filters">
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            flexWrap={"wrap"}
            columnGap={"20px"}
            rowGap={"20px"}
          >
            <DatePickerEl
              defaultDate={startDate}
              handleChange={(time) => handleDateChange(time, "start")}
              label="From"
            />
            <DatePickerEl
              defaultDate={endDate}
              handleChange={(time) => handleDateChange(time, "end")}
              label="To"
            />

            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              flexWrap={"wrap"}
              columnGap={"20px"}
              rowGap={"20px"}
            >
              <Select
                sx={{
                  width: "200px",
                }}
                size="small"
                value={shipmentMode}
                onChange={handleShipmentChange}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"AIR"}>Air</MenuItem>
                <MenuItem value={"ROAD"}>Road</MenuItem>
              </Select>

              <Select
                sx={{
                  width: "200px",
                }}
                size="small"
                value={paymentMode}
                onChange={handlePaymentChange}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"PREPAID"}>Prepaid</MenuItem>
                <MenuItem value={"COD"}>COD</MenuItem>
              </Select>





{!isUser && (<>
              <Select
                sx={{
                  width: "200px",
                }}
                size="small"
                value={serviceMode ?? "Fedex"}
                onChange={handleServiceFilter}
              >
                {serviceData?.map((el, index) => {
                  return (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  );
                })}
              </Select></>)}
            </Stack>
          </Stack>
        </div>

        <div className="order-filter-button">
          <Button
            onClick={() => setOpenFilter(true)}
            sx={{
              padding: "6px 20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
              fontSize: "12px",
            }}
            variant="contained"
          >
            <FilterAlt
              sx={{
                fontSize: "16px",
              }}
            />
            <p>Filters</p>
          </Button>
        </div>
      </Stack>

      {/* first table */}
      <TableContainer component={Card}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "calc(100% / 8)" }}>Date</TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                Total Order
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                Pickup Unscheduled
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                Pickup Scheduled
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                InTransit
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                Delivered
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                RTO
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                Cancelled
              </TableCell>
              <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                Exception
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data?.orders_by_date.map((row, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ width: "calc(100% / 8)" }}>
                    {row?.date}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.total_orders}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.pickup_unscheduled}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.pickup_scheduled}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.in_transit}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.delivered}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.rto}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.cancelled}
                  </TableCell>
                  <TableCell sx={{ width: "calc(100% / 8)" }} align="center">
                    {row?.exception}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <NoDataFound data={data?.orders_by_date ?? []} />
      </TableContainer>

      <StyledSeperator />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} xl={6}>
          <Card>
            <Stack
              direction={"row"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              gap={2.9}
            >
              <HailIcon
                color="primary"
                sx={{
                  fontSize: "33px",
                  border: "1px solid #eceef0",
                  borderRadius: "50%",
                  padding: "0px",
                }}
              />
              <Typography variant="h6" fontWeight={"500"}>
                Top 10 Customers
              </Typography>
            </Stack>

            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "33%" }}>Customer Name</TableCell>
                    <TableCell sx={{ width: "33%" }}>Total Order</TableCell>
                    <TableCell sx={{ width: "33%" }}>Revenue</TableCell>
                  </TableRow>
                </TableHead>
                {customerData &&
                  customerData?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ width: "33%" }}>
                        {row.person_name}
                      </TableCell>
                      <TableCell sx={{ width: "33%" }}>
                        {row.order_count}
                      </TableCell>
                      <TableCell sx={{ width: "33%" }}>
                        ₹{row.revenue}
                      </TableCell>
                    </TableRow>
                  ))}
              </Table>
              <NoDataFound data={customerData ?? []} />
            </TableContainer>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <Card>
            <Stack
              direction={"row"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              gap={2.9}
            >
              <InventoryIcon
                color="primary"
                sx={{
                  fontSize: "33px",
                  border: "1px solid #eceef0",
                  borderRadius: "50%",
                  padding: "0px",
                }}
              />
              <Typography variant="h6" fontWeight={"500"}>
                Top 10 Products
              </Typography>
            </Stack>

            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "33%" }}>Product Name</TableCell>
                    <TableCell sx={{ width: "33%" }}>Unit Sold</TableCell>
                    <TableCell sx={{ width: "33%" }}>Revenue</TableCell>
                  </TableRow>
                </TableHead>
                {productData &&
                  productData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ width: "33%" }}>
                        {row.product_name}
                      </TableCell>
                      <TableCell sx={{ width: "33%" }}>
                        {row.unit_sold}
                      </TableCell>
                      <TableCell sx={{ width: "33%" }}>
                        ₹{row.revenue}
                      </TableCell>
                    </TableRow>
                  ))}
              </Table>
              <NoDataFound data={productData ?? []} />
            </TableContainer>
          </Card>
        </Grid>
      </Grid>

      <StyledSeperator />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} xl={6}>
          <Card>
            <Stack direction={"column"}>
              <Stack
                direction={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                gap={2.9}
              >
                <PublicIcon
                  color="primary"
                  sx={{
                    fontSize: "30px",
                    border: "1px solid #eceef0",
                    borderRadius: "50%",
                    padding: "0px",
                  }}
                />
                <Typography variant="h6">Top 10 Cities</Typography>
              </Stack>
              <StyledSeperator />
              <Box>
                <List sx={{ listStyleType: "disc" }}>
                  {data &&
                    data.top_10_cities?.map((row: string, index: number) => (
                      <>
                        <Stack
                          direction={"row"}
                          justifyContent={"flex-start"}
                          margin={1}
                          alignItems={"center"}
                          gap={1}
                        >
                          <TrackChangesIcon
                            color="primary"
                            sx={{
                              fontSize: "15px",
                              border: "1px solid #eceef0",
                              borderRadius: "50%",
                              padding: "0px",
                            }}
                          />
                          <Typography fontSize={22}>{row}</Typography>
                        </Stack>
                      </>
                    ))}
                  <NoDataFound data={data?.top_10_cities ?? []} />
                </List>
              </Box>
            </Stack>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} xl={6}>
          {(data && data.cod_orders && data.prepaid_prders && (
            <Card>
              <Typography variant="h6" fontWeight={"500"}>
                Prepaid vs. COD Orders
              </Typography>
              <StyledSeperator />

              <Box padding={"20px"}>
                <PieChart
                  colors={[
                    "#719bda",
                    "#40a3d4",
                    "#49708d",
                    "#7ca7df",
                    "#7be7e7",
                  ]}
                  series={[
                    {
                      data: [
                        {
                          id: 0,
                          value: data?.prepaid_prders,
                          label: "PREPAID",
                        },
                        {
                          id: 1,
                          value: data?.cod_orders,
                          label: "COD",
                        },
                      ],
                    },
                  ]}
                  width={350}
                  height={200}
                />
              </Box>
            </Card>
          )) || <div></div>}
        </Grid>
      </Grid>

      <OrderTabFilter
        open={openFilter}
        startDate={startDate}
        endDate={endDate}
        onClose={() => setOpenFilter(false)}
        handleDateChange={handleDateChange}
        shipmentMode={shipmentMode}
        handleShipmentChange={handleShipmentChange}
        paymentMode={paymentMode}
        handlePaymentChange={handlePaymentChange}
        serviceMode={serviceMode as string}
        handleServiceFilter={handleServiceFilter}
      />
    </>
  );
};

export default OrderTab;
